import React from "react";
import { StyledButtonWithIcon } from "@aureskonnect/react-ui";
import { useSelector } from "react-redux";

export function CustomMainColorButtonWithIcon(props: any) {
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );

    return <StyledButtonWithIcon {...props} variant={mainColor} />;
}
